<template>
  <Content>
    <Block>
      <BlockHeader>
        <h1>{{ $t('what_to_expect_header') }}</h1>
        <p>{{ $t('what_to_expect_welcome') }}</p>
      </BlockHeader>
      <p>{{ $t('what_to_expect_intro') }}</p>

      <ol class="bullet-points">
        <li>
          <h5>{{ $t('what_to_expect_camera_check_header') }}</h5>
          <p>{{ $t('what_to_expect_camera_check_body') }}</p>
        </li>
        <li>
          <h5>{{ $t('what_to_expect_assessments_header') }}</h5>
          <p>{{ $t('what_to_expect_assessments_body') }}</p>
        </li>
      </ol>

      <Button to="/video-info">{{ $t('button_continue') }}</Button>
    </Block>
  </Content>
</template>

<script>
import {
  Button,
  Content,
  Block,
  BlockHeader
} from '@neurotrack/web-shared-components'

export default {
  name: 'WhatToExpect',
  components: {
    Button, Content, Block, BlockHeader
  }
}
</script>

<style lang="scss">
.onboarding {
  margin: 4rem auto;
}
</style>
